
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Musk",
      function () {
        return require("private-next-pages/money-fortune/Musk.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Musk"])
      });
    }
  